import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '@ingka/button'
import plus from '@ingka/ssr-icon/paths/plus'
import minus from '@ingka/ssr-icon/paths/minus'

import { CATS_BY_ROOM_TYPE, CAT_ROOM_TYPES } from 'models/kiosk/constants'
import { updateFurnitureFilter as updateFurnitureFilterAction } from 'models/furniture/actions'

import './style.scss'
import classNames from 'classnames'

interface CategoryFiltersProps {
    updateFurnitureFilter: typeof updateFurnitureFilterAction
}

const CategoryFilters = ({ updateFurnitureFilter }: CategoryFiltersProps) => {
    const { t } = useTranslation()
    const [roomFilter, setRoomFilter] = useState<typeof CAT_ROOM_TYPES[number]['key']>(CAT_ROOM_TYPES[0].key)
    const [isExpanded, setIsExpanded] = useState(false)

    const onRoomClick = useCallback((roomKey) => {
        setRoomFilter(roomKey)
        updateFurnitureFilter({ roomType: roomKey })
    }, [setRoomFilter, updateFurnitureFilter])
    const onCatClick = useCallback((cat) => {
        const nextFilter: { category?: string, subCategory?: string, query?: string } = {}

        if (cat.catId) {
            nextFilter.category = cat.catId

            if (cat.subCatId) {
                nextFilter.subCategory = cat.subCatId
            }
        } else if (cat.query) {
            nextFilter.query = cat.query
        }

        updateFurnitureFilter(nextFilter)

    }, [updateFurnitureFilter])

    const roomFilters = CAT_ROOM_TYPES.map((room) => (
        <button
            className={`roomFilter ${roomFilter === room.key ? 'selected' : ''}`}
            onClick={() => onRoomClick(room.key)}
            key={room.key}
        >
            {room.label}
        </button>
    ))

    const content = CATS_BY_ROOM_TYPE[roomFilter].map((cat) => (
        <button className="category" onClick={() => { onCatClick(cat) }} key={cat.label}>
            {cat.label}
        </button>
    ))


    return (
        <div className={classNames('CategoryFilters', { isExpanded })}>
            <div>
                {roomFilters}
            </div>
            <div>
                {content}
            </div>
            <div className="catFooter">
                <Button
                    type='secondary'
                    ssrIcon={isExpanded ? minus : plus}
                    onClick={() => { setIsExpanded(!isExpanded) }}
                >
                    {t(isExpanded ? 'kiosk.view fewer categories' : 'kiosk.view more categories')}
                </Button>
            </div>
        </div>
    )
}

export default CategoryFilters
